/**
 * Approved currencies for contract creation as specified here:
 *  (https://help.letsdeel.com/hc/en-gb/articles/4407737591953-In-Which-Currencies-Can-Clients-Create-a-Contractor-Contract?utm_source=chatgpt.com)
 * This list gates contract creation to only these currencies
 */

export interface ApprovedCurrency {
  code: string;
  name: string;
  country: string;
}

export const APPROVED_CURRENCIES: ApprovedCurrency[] = [
  { code: 'AED', name: 'Dirham', country: 'United Arab Emirates' },
  { code: 'ALL', name: 'Lek', country: 'Albania' },
  { code: 'AMD', name: 'Dram', country: 'Armenia' },
  { code: 'ARS', name: 'Argentine Peso', country: 'Argentina' },
  { code: 'AUD', name: 'Australian Dollar', country: 'Australia' },
  { code: 'AZN', name: 'Manat', country: 'Azerbaijan' },
  { code: 'BAM', name: 'Convertible Mark', country: 'Bosnia and Herzegovina' },
  { code: 'BBD', name: 'Barbadian Dollar', country: 'Barbados' },
  { code: 'BDT', name: 'Taka', country: 'Bangladesh' },
  { code: 'BGN', name: 'Bulgarian Lev', country: 'Bulgaria' },
  { code: 'BHD', name: 'Bahrain Dinar', country: 'Bahrain' },
  { code: 'BMD', name: 'Bermudian Dollar', country: 'Bermuda' },
  { code: 'BND', name: 'Brunei Dollar', country: 'Brunei' },
  { code: 'BOB', name: 'Boliviano', country: 'Bolivia' },
  { code: 'BRL', name: 'Brazilian Real', country: 'Brazil' },
  { code: 'BSD', name: 'Bahamian Dollar', country: 'Bahamas' },
  { code: 'BWP', name: 'Pula', country: 'Botswana' },
  { code: 'BZD', name: 'Belize Dollar', country: 'Belize' },
  { code: 'CAD', name: 'Canadian Dollar', country: 'Canada' },
  { code: 'CDF', name: 'Congolais Franc', country: 'Democratic Republic of the Congo' },
  { code: 'CHF', name: 'Swiss Franc', country: 'Switzerland' },
  { code: 'CLP', name: 'Chilean Peso', country: 'Chile' },
  { code: 'CNY', name: 'Yuan', country: 'China' },
  { code: 'COP', name: 'Colombian Peso', country: 'Colombia' },
  { code: 'CRC', name: 'Colon', country: 'Costa Rica' },
  { code: 'CUP', name: 'Cuban Peso', country: 'Cuba' },
  { code: 'CVE', name: 'Cape Verdean Escudo', country: 'Cape Verde' },
  { code: 'CZK', name: 'Czech Krone', country: 'Czechia' },
  { code: 'DJF', name: 'Djibouti Franc', country: 'Djibouti' },
  { code: 'DOP', name: 'Dominican Peso', country: 'Dominican Republic' },
  { code: 'DZD', name: 'Algerian Dinar', country: 'Algeria' },
  { code: 'EGP', name: 'Egyptian Pound', country: 'Egypt' },
  { code: 'ETB', name: 'Birr', country: 'Ethiopia' },
  { code: 'EUR', name: 'Euro', country: 'Multiple Countries' },
  { code: 'FJD', name: 'Fiji Dollar', country: 'Fiji' },
  { code: 'GBP', name: 'Sterling Pound', country: 'Great Britain' },
  { code: 'GEL', name: 'Georgian Lari', country: 'Georgia' },
  { code: 'GHS', name: 'Ghana Cedi', country: 'Ghana' },
  { code: 'GIP', name: 'Gibraltar Pound', country: 'Gibraltar' },
  { code: 'GMD', name: 'Dalasi', country: 'Gambia' },
  { code: 'GNF', name: 'Guinea Franc', country: 'Guinea' },
  { code: 'GTQ', name: 'Quetzal', country: 'Guatemala' },
  { code: 'GYD', name: 'Guyana Dollar', country: 'Guyana' },
  { code: 'HKD', name: 'Hong Kong Dollar', country: 'Hong Kong' },
  { code: 'HNL', name: 'Lempira', country: 'Honduras' },
  { code: 'HTG', name: 'Gourde', country: 'Haiti' },
  { code: 'HUF', name: 'Hungarian Forint', country: 'Hungary' },
  { code: 'IDR', name: 'Indonesian Rupiah', country: 'Indonesia' },
  { code: 'ILS', name: 'Israeli New Shekel', country: 'Israel' },
  { code: 'INR', name: 'Indian Rupee', country: 'India' },
  { code: 'ISK', name: 'Icelandic Krone', country: 'Iceland' },
  { code: 'JMD', name: 'Jamaica Dollar', country: 'Jamaica' },
  { code: 'JOD', name: 'Jordanian Dinar', country: 'Jordan' },
  { code: 'JPY', name: 'Japanese Yen', country: 'Japan' },
  { code: 'KES', name: 'Schilling', country: 'Kenya' },
  { code: 'KGS', name: 'Som', country: 'Kyrgyzstan' },
  { code: 'KHR', name: 'Cambodian Riel', country: 'Cambodia' },
  { code: 'KMF', name: 'Comorian Franc', country: 'Comoros' },
  { code: 'KRW', name: 'South Korean Won', country: 'South Korea' },
  { code: 'KWD', name: 'Kuwaiti Dinar', country: 'Kuwait' },
  { code: 'KYD', name: 'Cayman Dollar', country: 'Cayman Islands' },
  { code: 'KZT', name: 'Tenge', country: 'Kazakhstan' },
  { code: 'LAK', name: 'Kip', country: 'Laos' },
  { code: 'LBP', name: 'Lebanese Pound', country: 'Lebanon' },
  { code: 'LKR', name: 'Sri Lanka Rupee', country: 'Sri Lanka' },
  { code: 'LSL', name: 'Lesotho Loti', country: 'Lesotho' },
  { code: 'MAD', name: 'Moroccan Dirham', country: 'Morocco' },
  { code: 'MDL', name: 'Moldovan Leu', country: 'Moldova' },
  { code: 'MGA', name: 'Malagasy Ariary', country: 'Madagascar' },
  { code: 'MKD', name: 'Denar', country: 'North Macedonia' },
  { code: 'MMK', name: 'Kyat', country: 'Myanmar' },
  { code: 'MNT', name: 'Tugrik', country: 'Mongolia' },
  { code: 'MOP', name: 'Pataca', country: 'Macao' },
  { code: 'MRO', name: 'Ouguiya', country: 'Mauritania' },
  { code: 'MUR', name: 'Mauritian Rupee', country: 'Mauritius' },
  { code: 'MVR', name: 'Maldivian Rufiyaa', country: 'Maldives' },
  { code: 'MWK', name: 'Malawian Kwacha', country: 'Malawi' },
  { code: 'MXN', name: 'Mexican Peso', country: 'Mexico' },
  { code: 'MYR', name: 'Ringgit', country: 'Malaysia' },
  { code: 'MZN', name: 'Metical', country: 'Mozambique' },
  { code: 'NAD', name: 'Namibian Dollar', country: 'Namibia' },
  { code: 'NGN', name: 'Naira', country: 'Nigeria' },
  { code: 'NIO', name: 'Cordoba Oro', country: 'Nicaragua' },
  { code: 'NOK', name: 'Norwegian Krone', country: 'Norway' },
  { code: 'NPR', name: 'Nepalese Rupee', country: 'Nepal' },
  { code: 'NZD', name: 'New Zealand Dollar', country: 'New Zealand' },
  { code: 'OMR', name: 'Omani Rial', country: 'Oman' },
  { code: 'PAB', name: 'Balboa', country: 'Panama' },
  { code: 'PEN', name: 'Nuevo Sol', country: 'Peru' },
  { code: 'PGK', name: 'Kina', country: 'Papua New Guinea' },
  { code: 'PHP', name: 'Philippine Peso', country: 'Philippines' },
  { code: 'PKR', name: 'Pakistanian Rupee', country: 'Pakistan' },
  { code: 'PLN', name: 'Zloty', country: 'Poland' },
  { code: 'PYG', name: 'Guarani', country: 'Paraguay' },
  { code: 'QAR', name: 'Qatari Rial', country: 'Qatar' },
  { code: 'RON', name: 'Romanian Leu', country: 'Romania' },
  { code: 'RSD', name: 'Serbian Dinar', country: 'Serbia' },
  { code: 'RWF', name: 'Rwandan Franc', country: 'Rwanda' },
  { code: 'SAR', name: 'Saudi Rial', country: 'Saudi Arabia' },
  { code: 'SEK', name: 'Swedish Krone', country: 'Sweden' },
  { code: 'SGD', name: 'Singapore Dollar', country: 'Singapore' },
  { code: 'SLL', name: 'Leone', country: 'Sierra Leone' },
  { code: 'SRD', name: 'Surinam Dollar', country: 'Suriname' },
  { code: 'SZL', name: 'Swazi Lilangeni', country: 'Eswatini' },
  { code: 'THB', name: 'Thai Baht', country: 'Thailand' },
  { code: 'TJS', name: 'Somoni', country: 'Tajikistan' },
  { code: 'TMT', name: 'Turkmen Manat', country: 'Turkmenistan' },
  { code: 'TND', name: 'Tunisian Dinar', country: 'Tunisia' },
  { code: 'TRY', name: 'Turkish Lira', country: 'Turkey' },
  { code: 'TTD', name: 'Trinidad and Tobago Dollar', country: 'Trinidad and Tobago' },
  { code: 'TWD', name: 'New Taiwan Dollar', country: 'Taiwan' },
  { code: 'TZS', name: 'Tanzania Shilling', country: 'Tanzania' },
  { code: 'UAH', name: 'Hryvnia', country: 'Ukraine' },
  { code: 'UGX', name: 'Ugandan Shilling', country: 'Uganda' },
  { code: 'USD', name: 'US Dollar', country: 'United States of America & Multiple Countries' },
  { code: 'UYU', name: 'Uruguay Peso', country: 'Uruguay' },
  { code: 'UZS', name: 'Uzbekistan Sum', country: 'Uzbekistan' },
  { code: 'VND', name: 'Dong', country: 'Vietnam' },
  { code: 'WST', name: 'Tala', country: 'Samoa' },
  { code: 'XOF', name: 'Central African Franc', country: 'Multiple Countries' },
  { code: 'ZAR', name: 'South African Ran', country: 'South Africa' },
];

/**
 * Get approved currency codes as an array
 */
export const getApprovedCurrencyCodes = (): string[] => {
  return APPROVED_CURRENCIES.map((currency) => currency.code);
};

/**
 * Check if a currency code is approved for contract creation
 */
export const isApprovedCurrency = (currencyCode: string): boolean => {
  return getApprovedCurrencyCodes().includes(currencyCode.toUpperCase());
};
